export default "__VITE_ASSET__pFWGTE0h__"